import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { U21Typography } from 'app/shared/u21-ui/components';
import { generateColor } from 'app/shared/utils/stringToColor';

import { selectAgent } from 'app/modules/session/selectors';
import { useMemo } from 'react';
import { useTheme } from '@mui/material/styles';

export const SwitchedOrgBanner = ({
  isOrgSwitched,
}: {
  isOrgSwitched?: boolean;
}) => {
  const { org_name: orgName, org_display_name: orgDisplayName } =
    useSelector(selectAgent);
  const theme = useTheme();

  const [backgroundColor, foregroundColor] = useMemo(() => {
    const backgroundColorInner = generateColor(orgName);
    return [
      backgroundColorInner,
      theme.palette.getContrastText(backgroundColorInner),
    ];
  }, [orgName, theme]);

  if (!isOrgSwitched) {
    return null;
  }

  return (
    <StyledBanner $backgroundColor={backgroundColor}>
      <StyledU21Typography $color={foregroundColor}>
        {orgDisplayName}
      </StyledU21Typography>
    </StyledBanner>
  );
};

interface StyledBannerProps {
  $backgroundColor: string;
}

const StyledBanner = styled.div<StyledBannerProps>`
  height: 24px;
  background: ${(props) => props.$backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledU21Typography = styled(U21Typography)<{ $color: string }>`
  .MuiTypography-root {
    color: ${(props) => props.$color};
  }
`;
